import { useState } from 'react';
import { useTestMode } from '../lib/testModeContext.jsx';
import TestModePanel from './TestModePanel.jsx';

export default function TestModeBanner() {
  const mode = useTestMode();
  const [open, setOpen] = useState(false);

  if (!mode.active) return null;

  return (
    <>
      <div
        role="status"
        className="sticky top-0 z-30 flex items-center justify-between gap-2 border-b border-yellow-500/40 bg-yellow-500/15 px-4 py-1.5 font-mono text-[10px] uppercase tracking-wider text-yellow-700 dark:text-yellow-200"
      >
        <span>
          test mode · portland
          {mode.mockLocation && (
            <span className="ml-2 normal-case tracking-normal">
              GPS → {mode.mockLocation.label || `${mode.mockLocation.lat.toFixed(3)}, ${mode.mockLocation.lng.toFixed(3)}`}
            </span>
          )}
          {mode.mockTimeIso && (
            <span className="ml-2 normal-case tracking-normal">
              clock → {new Date(mode.mockTimeIso).toLocaleString()}
            </span>
          )}
        </span>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="rounded-full border border-yellow-500/50 px-2 py-0.5 hover:bg-yellow-500/20"
        >
          {open ? 'hide panel' : 'panel'}
        </button>
      </div>
      {open && <TestModePanel onClose={() => setOpen(false)} />}
    </>
  );
}
